import { modifier } from 'ember-modifier';

const DATA_HAS_NAVIGATION = 'data-has-navigation';

function toggleBodyNavigationAttr(docked: boolean) {
  if (docked) {
    document.body.setAttribute(DATA_HAS_NAVIGATION, '');
  } else {
    document.body.removeAttribute(DATA_HAS_NAVIGATION);
  }
}

export default modifier(
  (
    _el: HTMLElement,
    [docked = true]: [boolean],
    _options: {}
  ) => {
    toggleBodyNavigationAttr(docked);
    return () => {
    };
  },
  { eager: false }
);
